export default __webpack_public_path__ + "static/media/RC.a1c7d1e9.webp";